import { BrowserRouter, Route, Routes } from 'react-router';
import App from './components/App';
import LoggedInApp from './components/LoggedInApp';
import LoginForm from './components/LoginForm';
import Logout from './components/Logout';
import Register from './components/register/Register';
import AdminArea from './components/admin/AdminArea';
import Users from './components/admin/Users';
import Points from './components/admin/points/Points';
import AddPoints from './components/admin/points/AddPoints';
import Email from './components/admin/Email';
import MatchDays from './components/admin/matchDays/MatchDays';
import EditMatchDay from './components/admin/matchDays/EditMatchDay';

export default function Router() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<App />}>
          <Route index element={<LoggedInApp />} />
          <Route path="login" element={<LoginForm />} />
          <Route path="logout" element={<Logout />} />
          <Route path="register" element={<Register />} />
          <Route path="admin" element={<AdminArea />}>
            <Route path="users" element={<Users />} />
            <Route path="points" element={<Points />} />
            <Route path="points/add" element={<AddPoints />} />
            <Route path="match-days" element={<MatchDays />} />
            <Route path="match-days/:id/edit" element={<EditMatchDay />} />
            <Route path="email" element={<Email />} />
          </Route>
        </Route>
      </Routes>
    </BrowserRouter>
  );
}
